import React, { useState } from "react";
import styles from "./FlowLogin.module.scss";
import useScreenSize from "./hook/useScreenSize";
import BannerSlider from "./components/BannerSlider/BannerSlider";
import logoAfinandoMobile from "../../assets/images/logo_afinando_mobile.svg";
// logo do afinandinho sem skins
import logoAfinando from "../../assets/images/logo_afinando.png";
// logo do afinandinho com skins de páscoa
import logoCoelhoAfinandinho from "../../assets/images/logo_pascoa.svg";
// logo do afinandinho com skins de festa junina
import logoJuninoAfinandinho from "../../assets/images/logo_junino.png";
// logo do afinandinho com skins de natal
import logoNatalAfinandinho from "../../assets/images/logo-natal-login.svg";
import AuthForm from "./components/AuthForm/AuthForm";

// import do texto alternativo de logo para o afinandinho sem skins
import { ALT_LOGO_AFINANDO } from "../../constants/global";
// import do texto alternativo de logo para o afinandinho com skins de páscoa
import { ALT_LOGO_AFINANDO_PASCOA } from "../../constants/global";
// import do texto alternativo de logo para o afinandinho com skins de festa junina
import { ALT_LOGO_AFINANDO_JUNINO } from "../../constants/global";

import { ALT_LOGO_AFINANDO_NATAL } from "../../constants/global";
import { Box } from "@mui/material";
import bgBase from "./assets/images/login_singUp/bg_base.png";

/**
 * Componente de fluxo de login
 *
 * Este componente renderiza a tela de login/registro com um banner lateral
 * e formulário de autenticação. O componente adapta sua visualização
 * baseado no tamanho da tela do dispositivo.
 */
const FlowLogin = () => {
  const themes = [
    {
      name: "pascoa",
      start: new Date("2026-03-05T00:00:00"),
      end: new Date("2026-04-15T23:59:59"),
      logo: logoCoelhoAfinandinho,
      alt: ALT_LOGO_AFINANDO_PASCOA,
      className: styles.logo,
    },
    {
      name: "junina",
      start: new Date("2025-06-01T00:00:00"),
      end: new Date("2025-07-29T23:59:59"),
      logo: logoJuninoAfinandinho,
      alt: ALT_LOGO_AFINANDO_JUNINO,
      className: styles.logo,
    },
    {
      name: "natal",
      start: new Date("2025-11-30T00:00:00"),
      end: new Date("2026-01-15T23:59:59"),
      logo: logoNatalAfinandinho,
      alt: ALT_LOGO_AFINANDO_NATAL,
      className: styles.logo,
    },
  ];

  const getCurrentTheme = () => {
    const now = new Date();
    return themes.find(({ start, end }) => now >= start && now <= end);
  };

  // Estado para controlar se o usuário já está registrado
  const [isRegistered, setIsRegistered] = useState(false);

  // Hook personalizado para obter o tamanho da tela atual
  const screenWidth = useScreenSize();

  const currentTheme = getCurrentTheme();

  return (
    <Box
      sx={{
        width: "100%",
        flex: 1,
        minHeight: 0,

        display: "flex",
        justifyContent: "center",
        alignItems: "stretch",

        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          flex: 1,
          minHeight: 0,

          display: "grid",

          gridTemplateColumns: {
            xs: "1fr",
            md: "2fr 3fr",
          },

          gridTemplateRows: {
            xs: "auto auto",
            md: "1fr",
          },

          gridTemplateAreas: {
            xs: `
        "auth_banner"
        "auth_content"
      `,
            md: `"auth_content auth_banner"`,
          },

          backgroundColor: {
            xs: "#662d91",
            md: "transparent",
          },
        }}
      >
        <Box
          sx={{
            gridArea: "auth_content",
            padding: {
              xs: "0.5rem",
              sm: "2.5rem",
            },
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",

            backgroundColor: {
              xs: "#fff",
              md: "transparent",
            },

            borderRadius: {
              xs: "2.438rem 2.438rem 0 0",
              md: 0,
            },
          }}
        >
          <Box
            sx={{
              width: "fit-content",
              fontWeight: 500,
            }}
          >
            <Box
              component="img"
              src={currentTheme?.logo || logoAfinando}
              alt={currentTheme?.alt || ALT_LOGO_AFINANDO}
              sx={{
                width: {
                  xs: "6rem",
                  sm: "7rem",
                  md: "9.3rem",
                },
                marginBottom: "5rem",
                display: {
                  xs: "none",
                  md: "block",
                },
              }}
            />
            <AuthForm
              isRegistered={isRegistered}
              setIsRegistered={setIsRegistered}
            />
          </Box>
        </Box>

        <Box
          sx={{
            gridArea: "auth_banner",
            backgroundColor: "#6d329a",
            backgroundImage: `url(${bgBase})`,

            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",

            width: "100%",
            overflow: "hidden",

            height: {
              xs: "auto",
              sm: "60vh",
              md: "100%",
            },
          }}
        >
          {screenWidth <= 992 && (
            <Box
              component="img"
              src={logoAfinandoMobile}
              alt="Logo afinando o cérebro"
              sx={{
                display: {
                  xs: "block",
                  md: "none",
                },
                width: {
                  xs: "50%",
                  sm: "30%",
                  md: "30%",
                },
                marginTop: "1.125rem",
                paddingBottom: "2rem",
              }}
            />
          )}
          <BannerSlider />
        </Box>
      </Box>
    </Box>
  );
};

export default FlowLogin;
